import React from 'react';
import { Route } from '@/navigation/Route';
import { CommunicationScreen } from '@/features/communication/screens/Communication';
import { CommunicationListScreen } from './screens/CommunicationList';
import { CommunicationViewScreen } from './screens/CommunicationView';
import { CommunicationEditScreen } from './screens/CommunicationEdit';

export const COMMUNICATION_ROUTE = {
  communication: '/communication',
  communicationList: '/communication-list',
  communicationDetail: '/communication-detail/:id',
  communicationEdit: '/communication/:id/edit',
};

export const CommunicationNavigation = (): JSX.Element => (
  <>
    <Route
      exact
      path={COMMUNICATION_ROUTE.communication}
      component={CommunicationScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={COMMUNICATION_ROUTE.communicationList}
      component={CommunicationListScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={COMMUNICATION_ROUTE.communicationDetail}
      component={CommunicationViewScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={COMMUNICATION_ROUTE.communicationEdit}
      component={CommunicationEditScreen}
      isPrivateRoute
    />
  </>
);
